module.exports = __webpack_public_path__ + "media/images/game_icon/vi/VG1002-4c224299a2b098bb8b9b3fdff1534643.png";